import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Spinner } from 'seagull';
import EmptyState from '~/components/EmptyState/EmptyState';
import InvoicesTable from '~/components/InvoicesTable/InvoicesTable';
import { useStore } from '~/contexts';
import { useIntegrationsSummary } from '~/hooks/reactQuery/queries/useIntegrationsSummary';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import MinisiteTabHeader from '../MinisiteTabHeader/MinisiteTabHeader';
import styles from './InvoicesView.module.scss';
export default function InvoicesView(props) {
    const { agreement, refreshAgreement } = props;
    const { t: emptyStateTexts } = useLocaleKeys('pages.agreementMinisite.invoicesView.emptyState');
    const showQboIntegration = useStore(selectors.integration.showQboIntegration);
    useIntegrationsSummary({
        enabled: showQboIntegration,
        refreshOnHookMount: true
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MinisiteTabHeader, {}),
            /*#__PURE__*/ _jsx("div", {
                className: styles.container,
                "data-testid": "agreement-invoices-view",
                children: /*#__PURE__*/ _jsx(InvoicesTable, {
                    filtersClassname: styles.filters,
                    relationshipId: agreement.id,
                    renderLoader: ()=>/*#__PURE__*/ _jsx(Spinner, {
                            centeredInBox: true,
                            centerBoxHeight: 300
                        }),
                    renderNoInvoices: ()=>/*#__PURE__*/ _jsx(EmptyState, {
                            testId: "invoices-view-empty-state",
                            illustration: "invoices",
                            paragraphs: [
                                emptyStateTexts.intro(),
                                emptyStateTexts.noInvoicesYet()
                            ]
                        }),
                    onRetry: async ()=>{
                        await refreshAgreement({
                            silent: true
                        });
                    }
                })
            })
        ]
    });
}
